import type { JSX } from 'react';

import { VenmoButton as VenmoButtonInner } from 'src/app/shared/components/payments';

import { useShowVenmoButton } from '../../hooks/useShowVenmoButton';
import type { ModalCallbackProps } from '../../shared/types';

import { useVenmoButton } from './hooks/useVenmoButton';

export function VenmoButton(modalCallbackProps: ModalCallbackProps): JSX.Element | null {
	const { data, actions } = useVenmoButton(modalCallbackProps);

	const showVenmoButton = useShowVenmoButton();

	if (!showVenmoButton) return null;

	return <VenmoButtonInner {...data} {...actions} />;
}
